<template>
  <div class="admin-translate">
    <header-title title="Traducciones Postres"></header-title>
    <v-row align="start">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-text-field
          outlined
          dense
          label="Buscar"
          v-model="search"
          class="select-box ml-2"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <v-container fluid>
      <template>
        <div v-for="dessert in paginatedData" :key="dessert.id">
          <TranslateCartasPrincipales
            :data="dessert"
            @saveToCollection="saveToDessertCollection"
          ></TranslateCartasPrincipales>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(filteredDessert.length / size)"
            circle
            @input="nextPage"
            :total-visible="6"
            color="black"
          ></v-pagination>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import Loader from "../../../components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import TranslateCartasPrincipales from "@/components/admin/translate/TranslateCartasPrincipales";
import { dessertCollection, updateDessert } from "@/collections/dessert";

export default {
  name: "TranslateDessert",
  components: {
    HeaderTitle,
    Loader,
    TranslateCartasPrincipales
  },
  data() {
    return {
      dialogLoader: true,
      search: "",
      dessertCollection: [],
      pageNumber: 1,
      size: 2
    };
  },
  firestore() {
    return {
      dessertCollection: dessertCollection
    };
  },
  mounted() {
    setTimeout(() => {
      this.dialogLoader = false;
    }, 1000);
  },
  computed: {
    filteredDessert() {
      let _dessert = [...this.dessertCollection];
      _dessert = [
        ..._dessert.map(dessert => {
          dessert.ingredients.map(ingredient => {
            return (ingredient.trans = {
              en: ingredient.trans ? ingredient.trans.en : ingredient.item,
              es: ingredient.trans ? ingredient.trans.es : ingredient.item,
              it: ingredient.trans ? ingredient.trans.it : ingredient.item,
              fr: ingredient.trans ? ingredient.trans.fr : ingredient.item,
              de: ingredient.trans ? ingredient.trans.de : ingredient.item
            });
          });
          return dessert;
        })
      ];

      return this.search
        ? _dessert.filter(dessert =>
            dessert?.name?.toLowerCase().includes(this.search?.toLowerCase())
          )
        : _dessert;
    },
    paginatedData() {
      let start = this.pageNumber * this.size - this.size;
      let end = start + this.size;
      return this.filteredDessert.slice(start, end);
    }
  },
  methods: {
    nextPage(page) {
      this.pageNumber = page;
    },
    async saveToDessertCollection(input) {
      try {
        await updateDessert(input.id, input);
        this.showSuccessMessage("Traducciones Postres actualizado");
      } catch (error) {
        this.setlogError(
          "update_dessert",
          "Obtained error message in saveToDessertCollection()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
